import { translate } from 'secullum-i18n';
import { BatidasItem, ValoresItem } from './types';

export interface ColunaImpressao {
  id: string;
  description: string;
  selected: boolean;
}

export const obterColunasSelecionadas = (
  colunasImpressao: ColunaImpressao[]
) => {
  return colunasImpressao.filter(x => x.selected).map(x => x.id);
};

export const montarColunasImpressao = (
  batidas: BatidasItem[],
  totais: ValoresItem[],
  colunasSelecionadasImpressao: string[]
) => {
  const colunasImpressao: ColunaImpressao[] = [];

  for (let i = 1; i <= batidas.length / 2; i++) {
    colunasImpressao.push({
      id: `Entrada ${i}`,
      description: `${translate('Entrada')} ${i}`,
      selected: colunasSelecionadasImpressao.includes(`Entrada ${i}`)
    });

    colunasImpressao.push({
      id: `Saída ${i}`,
      description: `${translate('Saída')} ${i}`,
      selected: colunasSelecionadasImpressao.includes(`Saída ${i}`)
    });
  }

  for (let i = 0; i < totais.length; i++) {
    colunasImpressao.push({
      id: totais[i].nomeOriginal,
      description: totais[i].nome,
      selected: colunasSelecionadasImpressao.includes(totais[i].nomeOriginal)
    });
  }

  return colunasImpressao;
};
